<template>
  <router-view name="campaignReports" v-bind:key="$route.path"></router-view>
</template>
<script>
export default {
  name: "CampaignReports",
};
</script>